export const EDIT_MODEL_API_URI = '/rest/greenhopper/1.0/rapidviewconfig/editmodel.json';
export const CARD_LAYOUT_API_URI = '/rest/greenhopper/1.0/cardlayout';
export const SHOW_DAYS_IN_COLUMN_URI = '/rest/greenhopper/1.0/rapidviewconfig/showDaysInColumn';
